export default {
  label: "Comentarios",
  placeholder: {
    label: "Juan Pérez",
    initials: "JP",
  },
};
